import React from "react";
import { Box } from "@mui/material";
import { Footer, Header } from "./template";
import { AppThemeProvider, DrawerProvider } from "../../context";

export interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <AppThemeProvider>
      <DrawerProvider>
        <Header />
        <Box>{children}</Box>
        <Footer />
      </DrawerProvider>
    </AppThemeProvider>
  );
}
